module.exports = __webpack_public_path__ + "images/156_160.jpg";